import { render, staticRenderFns } from "./DelaySettings.vue?vue&type=template&id=11873716"
import script from "./DelaySettings.vue?vue&type=script&lang=js"
export * from "./DelaySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports